<kendo-window  *ngIf="opened">
    <kendo-window-titlebar  style="background-color:#1976d2; ">
      <div style="background-color:#1976d2; font-size: 18px; line-height: 1.3em;">
        System Message
      </div>
    </kendo-window-titlebar>

      <p style="margin: 30px; text-align: center;">A new version of Website is available. Loading new version...</p>
      <div class="text-right">
    </div>
  </kendo-window>

  <div kendoWindowContainer></div>
<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
<div kendoDialogContainer></div>